import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { HttpStatus } from '@shared/api/common/http-status.enum';

@Injectable()
export class AccountInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.router.url.startsWith('/account')) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status === HttpStatus.Unauthorized) {
            this.router.navigate(['login'], { queryParams: { error: 'loginTimeout' } });
          }
        },
      }),
    );
  }
}
